import { render, staticRenderFns } from "./HelpImportant.vue?vue&type=template&id=36e58c00&lang=pug&"
import script from "./HelpImportant.vue?vue&type=script&lang=ts&"
export * from "./HelpImportant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports